import { Component, OnInit, Input } from '@angular/core';
import { SessaoUtil } from '../../../util/sessao-util';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from '../../../util/util.service';
import { CadastroModalUtil } from '../../../util/modal/cadastro.modal.util';
import { SharedComponent } from '../shared.component';

declare var $: any;

@Component({
  selector: 'ats-barra-botoes',
  templateUrl: './barra-botoes.component.html',
  styleUrls: ['./barra-botoes.component.scss']
})
export class BarraBotoesComponent extends SharedComponent implements OnInit {

  @Input() titulo: String = "";
  @Input() botaoSalvar: any = {};
  @Input() botoesAdicionais: Array<any>;
  @Input() disabledSalvar: boolean = false;
  @Input() isModal: boolean = false;
  @Input() callBackOnVoltar: Function;
  @Input() callBackOnCloseModal: Function;

  constructor(
    private route: ActivatedRoute,
    private cadastroModalUtil: CadastroModalUtil,
    private sessaoUtil: SessaoUtil
  ) {
    super(route, sessaoUtil);
  }

  ngOnInit() {
    var self = this;

    this.setModo(this.cadastroModalUtil.modo);

    if(self.isModal == undefined || self.isModal == null){
      self.isModal = false;
    }

    if (UtilService.empty(self.botaoSalvar)) {
      self.botaoSalvar = {
        label: 'Salvar',
        className: 'btn btn-info',
        icon: 'fa fa-save',
        visible: true
      };
    } else {
      if (UtilService.empty(self.botaoSalvar.className)) {
        self.botaoSalvar.className = 'btn btn-info';
      }

      if (UtilService.empty(self.botaoSalvar.icon)) {
        self.botaoSalvar.icon = 'fa fa-save';
      }

      if (self.botaoSalvar.visible == undefined || self.botaoSalvar.visible == null) {
        self.botaoSalvar.visible = true;
      }

      if (UtilService.empty(self.botaoSalvar.label)) {
        self.botaoSalvar.label = 'Salvar';
      }

    }

    $('div.barra-botoes-fixada').css('top', '20px');

    $(document).ready(function () {
        $(window).scroll(function () {
          $('div.barra-botoes-fixada').css('top', ($(window).scrollTop() + 20)+'px');
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/componentes/barra-botoes/barra-botoes.component.ts